module.exports = __webpack_public_path__ + "static/img/18b.a1738d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/18b.png
// module id = 9kVy
// module chunks = 1